import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ComponentLoader from './component-loader'

const Onboarding = ComponentLoader(lazy(() => import('screens/auth/onboarding')))

const OnboardingRoutes = [
  {
    path: 'onboarding',
    element: <Onboarding />,
  },
  {
    path: '*',
    element: <Navigate replace to={'onboarding'} />,
  },
]

export default OnboardingRoutes
